/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserResetPasswordUpdatePasswordInput = {
    username: string;
    password: string;
    token: string;
    clientMutationId?: string | null;
};
export type ResetUserPasswordUpdatePasswordMutationVariables = {
    input: UserResetPasswordUpdatePasswordInput;
};
export type ResetUserPasswordUpdatePasswordMutationResponse = {
    readonly userResetPasswordUpdatePassword: {
        readonly clientMutationId: string | null;
        readonly authToken: string;
    } | null;
};
export type ResetUserPasswordUpdatePasswordMutation = {
    readonly response: ResetUserPasswordUpdatePasswordMutationResponse;
    readonly variables: ResetUserPasswordUpdatePasswordMutationVariables;
};



/*
mutation ResetUserPasswordUpdatePasswordMutation(
  $input: UserResetPasswordUpdatePasswordInput!
) {
  userResetPasswordUpdatePassword(input: $input) {
    clientMutationId
    authToken
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserResetPasswordUpdatePasswordPayload",
    "kind": "LinkedField",
    "name": "userResetPasswordUpdatePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetUserPasswordUpdatePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetUserPasswordUpdatePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0a931dd3e8c60fba3104053c58778ee0",
    "id": null,
    "metadata": {},
    "name": "ResetUserPasswordUpdatePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ResetUserPasswordUpdatePasswordMutation(\n  $input: UserResetPasswordUpdatePasswordInput!\n) {\n  userResetPasswordUpdatePassword(input: $input) {\n    clientMutationId\n    authToken\n  }\n}\n"
  }
};
})();
(node as any).hash = '1560f75e0fcab90341553a8417cf06cb';
export default node;
